<template>
  <div class="contents contents--pt">
    <div class="Movie_tv _min-h">
      <div class="inner">
        <!-- eslint-disable vue/no-v-html -->
        <div v-html="videoDetail.link" />
        <!--eslint-enable-->
        <div class="Zoom__class_area">
          <div class="Zoom__class_box">
            <div class="Zoom__class_box_head">
              クラス時間
            </div>
            <div class="Zoom__class_box_tx">
              {{ showDate(videoDetail.date) }}
              <span class="_mg-l1em">{{ videoDetail.learning_time }}～</span>
            </div>
          </div>
          <div class="Zoom__class_box">
            <div class="Zoom__class_box_head">
              クラス名
            </div>
            <div class="Zoom__class_box_tx" style="text-transform:capitalize;">
              {{ videoDetail.title }}
            </div>
          </div>
          <div class="Zoom__class_box">
            <div class="Zoom__class_box_head">
              インストラクター名
            </div>
            <div class="Zoom__class_box_tx">
              {{ videoDetail.master_instructor ? videoDetail.master_instructor.name : '' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import melontvService from '@/services/melontvService'
import moment from 'moment'
import melonLogService from '@/services/melonLogService'
export default {
  name: 'MelonTVVideo',
  data() {
    return {
      videoDetail: {},
      time: '',
      timeSite: '',
      updater: null,
      logID: null
    }
  },
  mounted() {
    this.getVideoDetail()
  },
  created() {
    this.updateLog()
  },
  beforeDestroy() {
    clearInterval(this.updater)
  },
  methods: {
    async getVideoDetail() {
      const search = this.$route.params.video_id
      const response = await melontvService.show(search)
      if (response !== undefined) {
        this.videoDetail = response.data
      }
      this.time = Date.now()
    },
    showDate(date) {
      if (date !== null) {
        return moment(date).locale('ja').format('MMMDo(ddd)')
      }
    },
    updateLog() {
      this.updater = setInterval(() => {
        if (this.videoDetail.id) {
          const data = {
            id: this.logID,
            melon_id: this.videoDetail.id,
            watch_time: 5,
            date: moment().format('YYYY-MM-DD HH:mm:ss')
          }
          melonLogService.add(data).then(data => {
            this.logID = data.data.id
          })
        }
      }, moment.duration('5', 'minutes').asMilliseconds())
    }
  }
}
</script>
